export default __webpack_public_path__ + "static/media/7.27f24c85.jpg";